import type { Subscription } from "@gs/core/domain/Subscription/Subscription";

export const getIsCustomSubscription = (sub: Subscription) => !sub.vendor_subscription_id;
